import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TipoCarretaService {
  constructor(private http: HttpClient) {}

  public GetTipoCarreta(): Observable<any> {
    const url = `${environment.baseURL}TipoCarreta/GetTipoCarretas`;
    return this.http.get<any>(url);
  }
}
